import React from "react";
import { Typography, Box, useMediaQuery } from "@mui/material";
import { GoogleSheetRedirection } from "../../api/Redirection";
import { useTheme } from "@mui/material/styles";
import HoverButton from "../HoverButton";

const SuitsDescription = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleGoogleSheetClick = () => {
     window.open(GoogleSheetRedirection, "_blank");
  };

  const styles = {
    container: {
      maxWidth: "100%",
      width: isMobile ? "90%" : "80%",
      marginTop: "5%",
      height: "auto",
      padding: "20px",
      ...(isMobile && { padding: "16px" }),
    },
    headingContainer: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: isMobile ? "flex-start" : "space-between",
      alignItems: isMobile ? "flex-start" : "center",
    },
    heading: {
      fontFamily: "ZapfHumnst BT",
      fontSize: {
        xs: "24px",
        sm: "32px",
        md: "36px",
        lg: "48px",
        xl: "48px",
      },
      lineHeight: { xs: "19.8px", sm: "39.71px" },
      fontWeight: 400,
      letterSpacing: "0.05em",
      textAlign: "left",
      color: "#181818",
      margin: 0,
    },
    button: {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      fontWeight: "400",
      fontFamily: "sora",
      backgroundColor: "transparent",
      border: "1px solid #442A0B",
      padding: "8px 12px",
      cursor: "pointer",
      color: "#442A0B",
      borderRadius: "0px",
      fontSize: "16px",
      boxShadow: "none",
      marginTop: isMobile ? "16px" : 0,
    },
    subheading: {
      fontFamily: "Sora",
      fontSize: {
        xs: "10px",
        sm: "14px",
        md: "16px",
        lg: "16px",
        xl: "18px",
      },
      fontWeight: 300,
      lineHeight: "26px",
      letterSpacing: "0.01em",
      textAlign: "left",
      textUnderlinePosition: "from-font",
      textDecorationSkipInk: "none",
      flex: isMobile ? "75%" : "75%",
      maxWidth: isMobile ? "100%" : "75%",
      marginTop: "16px",
      color: "#4D4D4D",
    },
    rectangle: {
      backgroundColor: "#F7EEE6",
      width: isMobile ? "100%" : "403px",
      height: "59px",
      opacity: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "20px",
    },
    rectangleText: {
      fontFamily: "Sora",
      fontSize: "16px",
      fontWeight: 300,
      lineHeight: "26px",
      letterSpacing: "0.01em",
      textAlign: "center",
      textUnderlinePosition: "from-font",
      textDecorationSkipInk: "none",
      color: "#4D4D4D",
    },
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.headingContainer}>
        <Typography variant="h1" sx={styles.heading}>
          THE TROPICAL SUITE
        </Typography>
        {!isMobile && (
          <HoverButton
            onClick={handleGoogleSheetClick}
            fontWeight={400}
            btnText={" CHECK AVAILABILITY"}
            width={isMobile ? "207px" : "231px"}
            sx={styles.button}
          />
        )}
      </Box>
      <Typography sx={styles.subheading}>
        Offers a vibrant escape surrounded by lush greenery and refreshing interiors. Designed with earthy textures and breezy accents, it creates a serene yet lively ambiance. Perfect for those seeking a rejuvenating stay amidst nature's charm.
      </Typography>
      {isMobile && (
        <HoverButton
          onClick={handleGoogleSheetClick}
          fontWeight={400}
          btnText={" CHECK AVAILABILITY"}
          width={isMobile ? "207px" : "231px"}
          sx={styles.button}
        />
      )}
      <Box sx={styles.rectangle}>
        <Typography sx={styles.rectangleText}>
          Check In: 02:00pm | Check Out: 11:00am
        </Typography>
      </Box>
    </Box>
  );
};

export default SuitsDescription;
